<script lang="ts" setup>
interface Props {
	size?: number;
}
defineProps<Props>();
</script>
<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="size ?? '24'"
		:height="size ?? '24'"
		fill="none"
	>
		<g clip-path="url(#clip0_2040_151619)">
			<path
				d="M0.664062 24.0002L2.35106 17.8372C1.31006 16.0332 0.763063 13.9882 0.764063 11.8912C0.767063 5.33524 6.10206 0.000244141 12.6571 0.000244141C15.8381 0.00124414 18.8241 1.24024 21.0701 3.48824C23.3151 5.73624 24.5511 8.72425 24.5501 11.9022C24.5471 18.4592 19.2121 23.7942 12.6571 23.7942C10.6671 23.7932 8.70606 23.2942 6.96906 22.3462L0.664062 24.0002ZM7.26106 20.1932C8.93706 21.1882 10.5371 21.7842 12.6531 21.7852C18.1011 21.7852 22.5391 17.3512 22.5421 11.9002C22.5441 6.43824 18.1271 2.01024 12.6611 2.00824C7.20906 2.00824 2.77406 6.44224 2.77206 11.8922C2.77106 14.1172 3.42306 15.7832 4.51806 17.5262L3.51906 21.1742L7.26106 20.1932ZM18.6481 14.7292C18.5741 14.6052 18.3761 14.5312 18.0781 14.3822C17.7811 14.2332 16.3201 13.5142 16.0471 13.4152C15.7751 13.3162 15.5771 13.2662 15.3781 13.5642C15.1801 13.8612 14.6101 14.5312 14.4371 14.7292C14.2641 14.9272 14.0901 14.9522 13.7931 14.8032C13.4961 14.6542 12.5381 14.3412 11.4031 13.3282C10.5201 12.5402 9.92306 11.5672 9.75006 11.2692C9.57706 10.9722 9.73206 10.8112 9.88006 10.6632C10.0141 10.5302 10.1771 10.3162 10.3261 10.1422C10.4771 9.97024 10.5261 9.84624 10.6261 9.64724C10.7251 9.44924 10.6761 9.27524 10.6011 9.12624C10.5261 8.97824 9.93206 7.51524 9.68506 6.92024C9.44306 6.34124 9.19806 6.41924 9.01606 6.41024L8.44606 6.40024C8.24806 6.40024 7.92606 6.47424 7.65406 6.77224C7.38206 7.07024 6.61406 7.78824 6.61406 9.25124C6.61406 10.7142 7.67906 12.1272 7.82706 12.3252C7.97606 12.5232 9.92206 15.5252 12.9031 16.8122C13.6121 17.1182 14.1661 17.3012 14.5971 17.4382C15.3091 17.6642 15.9571 17.6322 16.4691 17.5562C17.0401 17.4712 18.2271 16.8372 18.4751 16.1432C18.7231 15.4482 18.7231 14.8532 18.6481 14.7292Z"
				fill="#25D366"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2040_151619">
				<rect
					:width="size ?? '24'"
					:height="size ?? '24'"
					fill="white"
					transform="translate(0.664062 0.000244141)"
				/>
			</clipPath>
		</defs>
	</svg>
</template>
